<template>
  <v-dialog persistent :value="dialogShow" :max-width="maxWidth" style="position:relative;" content-class="box_instant">
    <v-icon
        size="30px"
        :class="['dialog-close-icon white--text close_instant']" color="white"
        @click="closeAction" v-if="closeAction != null">mdi-close-circle-outline
    </v-icon>
    <v-card class="dialog-card" style="border-radius:40px;" color="transparent">
      <v-row no-gutters class="dialog-header">
        <v-carousel
            cycle
            height="auto"
            interval="8000"
            hide-delimiter-background
            :hide-delimiters="arrayInfo.length <=1"
            :show-arrows="arrayInfo.length >1"
            show-arrows-on-hover
        >
          <v-carousel-item
              v-for="(k,i) in arrayInfo"
              :key="i"
          >
            <v-sheet
                height="100%"
                color="transparent"
            >
              <v-row
                  @click="goToPromoPage()"
                  class="fill-height"
                  align="center"
                  justify="center"
              >
                <v-col v-if="hasImage(k.message)" cols="12" :class="messageClass(k.message)"
                       v-html="formatMessage(k.message)"></v-col>
                <v-col v-else cols="12" :class="messageClass(k.message)">
                  <div v-if="k.title" class="popupTitle">{{ k.title }}</div>
                  <div v-html="formatMessage(k.message)"></div>
                </v-col>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import {ROUTE_NAME} from "@/constants/route.constants";

export default {
  name: "InstantPopupDialog",
  props: {
    arrayInfo: {
      type: Array,
      required: false,
      default: null
    },
    maxWidth: {
      type: Number,
      required: false,
      default: 500
    },
    closeAction: {
      required: false,
      default: null
    },
    dialogShow: {
      type: Boolean,
      required: true,
      default: false
    },
    redirectOnClick: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  methods:{
    hasImage(message) {
      return message != null && /<img[\s>]/i.test(message)
    },
    messageClass(message) {
      if (this.hasImage(message)) {
        return ['pa-0', 'popupImage']
      }
      return this.arrayInfo.length > 1 ? ['popupText', 'popupText--with-delimiters'] : ['popupText']
    },
    formatMessage(message) {
      if (message == null) {
        return ''
      }
      // Image popups are wrapped in <p> by the editor - the paragraph margins break the image centering.
      // Text popups keep their paragraphs so multi-paragraph announcements stay readable.
      if (this.hasImage(message)) {
        return message.replace(/<p[^>]*>/gi, ' ').replace(/<\/p>/gi, ' ')
      }
      return message
    },
    goToPromoPage(){
      // Payment popups are shown on the deposit/withdrawal page - tapping them must
      // not pull the member out of the transaction they are in the middle of.
      if (!this.redirectOnClick) {
        return
      }
      this.closeAction();
      this.$router.push({
        name: ROUTE_NAME.PROMOTION
      })
    }
  }
}
</script>

<style>
.close_instant {
  position: absolute;
  width: auto;
  float: right;
  top: 17px;
  right:2%;
  z-index: 99999;
  color: #ffffff !important;
  background: rgba(0, 0, 0, 0.55);
  border-radius: 50%;
}

.v-dialog.box_instant {
  box-shadow: none !important;
}

.popupImage {
  text-align: center;
}

/* Text-only announcements have no image to sit on, so they need their own
   readable surface - the dialog card itself is transparent. */
.popupText {
  margin: 5px;
  padding: 40px 30px !important;
  background: #ffffff;
  border-radius: 40px;
  color: #333333;
  font-size: 14px;
  line-height: 1.6;
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-height: 70vh;
  overflow-y: auto;
}

/* Title shown above text-only announcements (skipped for image popups). */
.popupTitle {
  font-size: 18px;
  font-weight: bold;
  text-decoration: underline;
  margin-bottom: 12px;
}

/* The carousel delimiters are absolutely positioned over the bottom 50px. */
.popupText--with-delimiters {
  margin-bottom: 55px;
}

.popupText p {
  margin-bottom: 8px;
}

.popupText p:last-child {
  margin-bottom: 0;
}

.popupImage img {
  text-align: center;
  width: 430px;
  height: auto;
  border-radius: 40px;
  overflow: hidden;
  will-change: transform;
  transform: translateZ(0);
}

@media (max-width: 750px) {
  .popupImage img {
    width: 385px;
    border-radius: 40px;
  }

  .close_instant {
    right: 20px;
  }
}

@media (max-width: 450px) {
  .popupImage img {
    width: 305px;
    border-radius: 40px;
  }

  .close_instant {
    right: 5px;
  }
}

</style>